import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { queryParamSelector, RouterAction } from '@cbridge-packages/routing';
import { SymbolPoolAction } from '../symbolPool.action';
import { NodeParam } from '../_helpers/nodeSearchParam';

type IState =
  & IGetSelectorStateType<typeof queryParamSelector>;

export const toggleSelectNodeEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(SymbolPoolAction.toggleSelect),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { nodeId } = payload;
    const currentId = queryParamSelector(state, NodeParam.name);

    if (String(nodeId) === currentId) {
      return [
        RouterAction.removeParam(NodeParam.name),
      ];
    }
    return [
      RouterAction.addParam(NodeParam.nameAndValue(String(nodeId))),
    ];
  }),
);
